import { render, staticRenderFns } from "./TractVisitForm.vue?vue&type=template&id=3cc712f5&"
import script from "./TractVisitForm.vue?vue&type=script&lang=js&"
export * from "./TractVisitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports